import { partnerApi } from 'shared/infrastructure/clients'

const getUserRequest = () => {
  return partnerApi.get(`/accesses/current`).then(response => response.data)
}

export { getUserRequest }
